<template>
  <div class="tw:flex">
    <div class="tw:flex-1">
      <BaseButton
        circle
        color="ai"
        data-testid="copy-button"
        icon="copy-content"
        new-design
        new-icon
        @click="handleCopyClick"
      >
        <BaseStreemTooltip
          anchor="top middle"
          self="bottom middle"
        >
          {{ getLocaleText("global.copy") }}
        </BaseStreemTooltip>
      </BaseButton>
    </div>

    <div class="tw:flex tw:flex-1 tw:justify-center">
      <Transition name="fade">
        <div
          v-if="copied"
          class="tw:rounded-md tw:bg-blue-700 tw:px-4 tw:py-2 tw:text-white"
        >
          {{ getLocaleText("ai_summary_panel.copied") }}
        </div>
      </Transition>
    </div>

    <div class="tw:flex tw:flex-1 tw:justify-end">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClipboard } from "@vueuse/core";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseStreemTooltip } from "shared/components/base";

interface AIChatActions {
  copyText?: string;
}

const props = defineProps<AIChatActions>();

const { copy, copied } = useClipboard({ copiedDuring: 3000 });

function handleCopyClick() {
  if (!props.copyText) return;

  copy(props.copyText);
}
</script>
